export default __webpack_public_path__ + "static/media/cbs.5bdabec3.png";